import { useState } from 'react';
import { useNavigate,useParams } from 'react-router-dom';
import { User, Lock } from 'lucide-react';
import styles from './Auth.module.css';
import FormInputChange from "../../../GlobalComponent/Utils/FormInputChange";
import { toast } from "react-toastify";
import { get_school_login_page_detail } from '../../../Service/ApiServices';
import FormValidation from "../../../GlobalComponent/Utils/FormValidation";
import { useAuth } from '../../../Service/AuthService';
import { useEffect } from 'react';
 import { school_code_valid } from '../../../Service/ApiServices';
// import logindefaultimage from '../../Images/best-parent-school.png';
export default function EntranceLoginForm() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [schoolCodeData, setSchoolCodeData] = useState("");
  const [formdata, setFormData] = useState({
    school_code:"",
    username: "",
    password: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [screenError, setScreenError] = useState(false);
  const [Data, setData] = useState();
  const [SchoolLoading, setSchoolLoading] = useState(true);

  const { login } = useAuth();
  const { school_code } = useParams();

  const handleInputChange = (e) => {
    FormInputChange(e, formdata, setFormData, false, errors, setErrors);
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (FormValidation(formdata, {}, setErrors, [])) {
      setLoading(true);
      try {
        const response = await login(formdata);
        if (response.status) {
          FormDatClear();
          toast.success("Login successful!");
          navigate("/EntranceExam");
        } else {
          toast.error(response.message || "Login failed!");
          setErrors({ message: response.message });
        }
      } catch (error) {
        const message = error?.response?.data?.message || "An error occurred while logging in!";
        toast.error(message);
      } finally {
        setLoading(false);
      }
    } else {
      toast.info("Username and password are required");
    }
  };

  const FormDatClear = () => {
    setFormData({
      username: "",
      password: "",
    });
  };

  // API call to validate school code
  useEffect(() => {
    school_code_valid({ school_code })
      .then((res) => {
        if (res.status) {
          setSchoolCodeData(res?.response?.data);
          setScreenError(false);
        } else {
          navigate('/EntranceExam/login');
        }
      })
      .catch((error) => {
        console.error("Error fetching school data:", error);
        navigate('/EntranceExam/login');  
      });
  }, [school_code]);



  // Fetch school login page details
  useEffect(() => {
    const abortController = new AbortController();
    if (school_code === schoolCodeData?.school_code) {
      get_school_login_page_detail(school_code, abortController.signal).then(res => {
        if (res.status) {
          setData(res?.response?.data);
        }
        setSchoolLoading(false);
      }).catch(() => {
        setSchoolLoading(false); // Hide loader on failure
      });
    }
    return () => {
      abortController.abort();
    };
  }, [school_code, schoolCodeData]);

  const image_url = process.env.REACT_APP_IMG_URL || 'https://sims.acstechconsulting.com/';

  const handleRoute = ()=>{
       navigate('/EntranceExam/signup')
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Welcome Back</h1>
        <form onSubmit={handlesubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <User className={styles.icon} size={18} />
            <input
             id="username" 
             name="username" 
             type="text"
             onChange={handleInputChange}
             value={formdata.username}
             required 
             className={styles.input} 
              valid={errors.username}
              placeholder="Username or Email" 
              />
          </div>
          <div className={styles.inputGroup}>
            <Lock className={styles.icon} size={18} />
            <input
             id="password" 
             name="password" 
             type="password" 
             onChange={handleInputChange}
             value={formdata.password}
             valid={errors.password}
             required
              className={styles.input} 
              placeholder="Password" 
              />
          </div>
          <div className={styles.inputGroup}>
            <Lock className={styles.icon} size={18} />
            <input
             id="school_code" 
             name="school_code" 
             type="password" 
             onChange={handleInputChange}
             value={formdata.school_code}
             valid={errors.school_code}
             required
              className={styles.input} 
              placeholder="school_code" 
              />
          </div>
          <button type="submit" className={styles.button} disabled={loading}>
            {isLoading ? 'Logging In...' : 'Log In'}
          </button>
        </form>
        <p className={styles.switchText}>
          Don't have an account?{' '}
          <a 
           onClick={handleRoute}
          className={styles.switchLink}>Sign Up</a>
        </p>
      </div>
    </div>
  );
}
